import React, { useState } from "react";
import Icon from "components/AppIcon";


// Recent documents — updated to reference canonical asset names
const documents = [
  {
    id: 1,
    name: "Solano Wind Farm SPV — Q4 2025 Report",
    type: "PDF",
    size: "2.4 MB",
    updated: "03/03/2026",
    category: "Quarterly Report",
    icon: "FileText",
    iconColor: "#DC2626",
  },
  {
    id: 2,
    name: "Thames Tidal Power SPV — IC Memorandum v3",
    type: "DOCX",
    size: "1.1 MB",
    updated: "01/03/2026",
    category: "IC Document",
    icon: "FileText",
    iconColor: "#2563EB",
  },
  {
    id: 3,
    name: "Nordic Fibre Network — Financial Model 2026",
    type: "XLSX",
    size: "5.8 MB",
    updated: "28/02/2026",
    category: "Financial Model",
    icon: "FileSpreadsheet",
    iconColor: "#059669",
  },
  {
    id: 4,
    name: "Porto Digital Hub SPV — Term Sheet",
    type: "PDF",
    size: "0.9 MB",
    updated: "25/02/2026",
    category: "Legal",
    icon: "FileText",
    iconColor: "#DC2626",
  },
  {
    id: 5,
    name: "ESG Framework — Annual Disclosure 2025",
    type: "PDF",
    size: "3.2 MB",
    updated: "20/02/2026",
    category: "ESG",
    icon: "Leaf",
    iconColor: "#059669",
  },
];

export default function RecentDocuments() {
  const [downloading, setDownloading] = useState(null);

  const handleDownload = (id) => {
    setDownloading(id);
    setTimeout(() => setDownloading(null), 1500);
  };

  return (
    <div className="card h-full" style={{ padding: 0 }}>
      <div className="flex items-center justify-between px-5 py-4 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="FolderOpen" size={18} color="var(--color-primary)" />
          <h3 className="font-heading font-semibold text-foreground" style={{ fontSize: "1rem" }}>
            Recent Documents
          </h3>
        </div>
        <span className="font-data text-muted-foreground text-xs">{documents?.length} files</span>
      </div>
      <div className="divide-y divide-border">
        {documents?.map((doc) => (
          <div key={doc?.id} className="flex items-center gap-3 px-5 py-3 hover:bg-muted transition-all duration-250">
            <div className="flex-shrink-0">
              <Icon name={doc?.icon} size={20} color={doc?.iconColor} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-caption font-medium text-foreground text-sm truncate">{doc?.name}</p>
              <div className="flex items-center gap-2 mt-0.5">
                <span
                  className="font-caption text-muted-foreground"
                  style={{ fontSize: "0.6875rem" }}
                >
                  {doc?.category}
                </span>
                <span className="text-border">·</span>
                <span className="font-data text-muted-foreground" style={{ fontSize: "0.6875rem" }}>
                  {doc?.size}
                </span>
                <span className="text-border">·</span>
                <span className="font-data text-muted-foreground" style={{ fontSize: "0.6875rem" }}>
                  {doc?.updated}
                </span>
              </div>
            </div>
            <button
              onClick={() => handleDownload(doc?.id)}
              className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted border border-border transition-all duration-250"
              aria-label={`Download ${doc?.name}`}
            >
              {downloading === doc?.id ? (
                <Icon name="Loader2" size={14} color="var(--color-primary)" className="animate-spin" />
              ) : (
                <Icon name="Download" size={14} color="var(--color-muted-foreground)" />
              )}
            </button>
          </div>
        ))}
      </div>
      <div className="px-5 py-3 border-t border-border">
        <button className="font-caption text-primary text-sm hover:underline transition-all">
          Open Data Room →
        </button>
      </div>
    </div>
  );
}